export default "__VITE_ASSET__CiqTjSPX__"